// Imported for side effects (module augmentation)
import './occ-order-endpoints.model';
